/**
 * ============================================================================
 *  SITE CONFIGURATION
 * ----------------------------------------------------------------------------
 *  Edit the values below to rebrand this template. These are the main knobs
 *  used across the app (header, footer, SEO, contact, payment page, etc.).
 * ============================================================================
 */

export const siteConfig = {
  brand: {
    name: 'USDT Flasher Website',
    tagline: 'USDT Flasher Website — Secure, Fast, Reliable',
    description:
      'USDT Flasher Website is the most reliable USDT flashing solution. Flash up to $10,000,000 USDT daily with our secure, tradable, swappable, and transferable flash USDT software.',
  },

  domain: 'https://usdtflasherwebsite.com',

  contact: {
    orderEmail: 'buyflashusdtsoftware@gmail.com',
    supportEmail: 'buyflashusdtsoftware@gmail.com',
    whatsapp: '18144751028',
    phoneDisplay: '+1 (814) 475-1028',
  },

  social: {
    twitter: 'https://twitter.com/yourbrand',
    facebook: 'https://facebook.com/yourbrand',
    instagram: 'https://instagram.com/yourbrand',
    telegram: 'https://t.me/yourbrand',
  },

  payment: {
    wallets: {
      bitcoin: 'bc1qlw4lcq87ue7l4tgn3m3j4ax7q2287hn5jgefqt',
      usdt: 'TNudmjRuhw29EMfVn7RHf2uEf8Lw9ePRFF',
    },
  },
};

export default siteConfig;
